"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import { useAppShellContext } from "../AppShell.context.mjs";
import AppShell_module_default from "../AppShell.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/AppShell/AppShellMain/AppShellMain.tsx
const AppShellMain = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("AppShellMain", null, _props);
	return /* @__PURE__ */ jsx(Box, {
		component: "main",
		...useAppShellContext().getStyles("main", {
			className,
			style,
			classNames,
			styles
		}),
		...others
	});
});
AppShellMain.classes = AppShell_module_default;
AppShellMain.displayName = "@mantine/core/AppShellMain";
//#endregion
export { AppShellMain };

//# sourceMappingURL=AppShellMain.mjs.map